module.exports = __webpack_public_path__ + "static/media/MobileSellerboxFunction04.d2e25815.png";